<template>
	<div class="wai">
		<div class="title">
			<div class="blue"></div>
			<div style="flex: 1;">标签管理</div>
		</div>
		<!-- 第三部分开始 -->
		<div style="margin-bottom: 20px; display: flex;">
			<div style="flex: 1;"><router-link to="addlabel"><el-button size="small"
						type="primary">新建标签</el-button></router-link></div>
			<div style="display: flex;">
				<el-input size="small" type="text" style="width: 180px;margin-right:10px;" v-model="filter.name"
					placeholder="请输入标签名称" />
				<el-button type="primary" @click="getlist" size="small">搜 索</el-button>
			</div>
		</div>
		<div>
			<el-table :header-cell-style="{'background-color':'#F9FCFF','text-align':'center'}"
				:cell-style="{'text-align':'center'}" :data="tableData" border style="width: 100%">
				<el-table-column prop="labelName" label="标签名称"></el-table-column>
				<el-table-column prop="labelDesc" label="标签描述"></el-table-column>
				<el-table-column prop="userTotal" label="用户数量" width="100"></el-table-column>
				<el-table-column label="最近是否购买" width="110">
					<template slot-scope="scope">
						{{scope.row.nearBuy?scope.row.nearBuy:"否"}}
					</template>
				</el-table-column>
				<el-table-column label="美团用户" width="80">
					<template slot-scope="scope">
						{{ scope.row.hasMeituan|labelFormat }}
					</template>
				</el-table-column>
				<el-table-column label="vip用户" width="100">
					<template slot-scope="scope">
						{{ scope.row.hasVip==0?"不判断" :scope.row.hasVip==1?"会员用户" :"非会员用户" }}
					</template>
				</el-table-column>
				<el-table-column label="最少交易次数" width="110">
					<template slot-scope="scope">
						{{ scope.row.minTransactions }}
					</template>
				</el-table-column>
				<el-table-column label="最多交易次数" width="110">
					<template slot-scope="scope">
						{{ scope.row.maxTransactions }}
					</template>
				</el-table-column>
				<!-- <el-table-column
					label="更新方式">
								<template slot-scope="scope">
									{{scope.row.updateWay?scope.row.updateWay:"/"}}
								</template>
				</el-table-column> -->
				<!-- <el-table-column
					label="修改时间">
							<template slot-scope="scope">
								{{ scope.row.updateTime }}
							</template>
				</el-table-column> -->
				<el-table-column label="累计付款金额" width="110">
					<template slot-scope="scope">
						{{scope.row.payTotal?scope.row.payTotal:"0.00"}}
					</template>
				</el-table-column>
				<el-table-column label="是否首次购买" width="110">
					<template slot-scope="scope">
						{{scope.row.firstBuy?scope.row.firstBuy:"否"}}
					</template>
				</el-table-column>
				<el-table-column label="需消费服务" width="110">
					<template slot-scope="scope">
						{{scope.row.services?scope.row.services:"无"}}
					</template>
				</el-table-column>
				<!-- 				<el-table-column label="消费过的门店">
					
				</el-table-column> -->
				<el-table-column align="center" label="操作">
					<template slot-scope="scope">
						<div style="display:flex;width: 80px;margin: auto;">
							<el-button type="text" style="flex: 1;" @click="gos(scope.row.id)">编辑</el-button>
							<!-- <el-button type="text" style="flex: 1;" @click="deletes(scope.row.id)">
								<span style="color: red;">删除</span>
							</el-button> -->
						</div>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				filter: {
					name: ""
				},
				//第三部分表格
				tableData: [],
				serviceList: [],
			}
		},
		mounted() {
			this.getlist();
			this.getService();
		},
		filters: {
			labelFormat(val) {
				if (val) return '是'
				return '否'
			}
		},
		methods: {
			gos(id) {
				this.$router.push({
					path: "addlabel",
					query: {
						id: id
					}
				})
			},
			getService() {
				let data = {
					pageNum: 1,
					pageSize: 100
				}
				this.$http.post("dhaircut/findDhaircutService", JSON.stringify(data)).then(res => {
					this.serviceList = res.body.data.records;
				})
			},
			//编辑
			deit(id) {
				this.$router.push({
					path: 'newopera',
					query: {
						id: id
					}
				})
			},
			// 删除
			deletes(id) {
				this.$confirm('此操作将永久删除该, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get("dUserLabel/remove?id=" + id).then(function(res) {
						if (res.body.code == 200) {
							this.$message.success("删除成功")
							this.getlist()
						}
					})
				});
			},
			getlist() {
				this.$http.get("dUserLabel/list?name=" + this.filter.name).then(function(res) {
					if (res.body.code == 200) {
						this.tableData = res.body.data
						this.tableData.map(ele => {
							if (ele.services) {
								let temp = [];
								this.serviceList.filter(i => {
									if (ele.services.split(',').includes(i.id + "")) {
										temp.push(i.title);
									}
								})
								ele.services = temp.toString();
							}
						})
					}
				})
			}
		}
	};
</script>
<style lang="less" scoped>
	.title {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;

		.blue {
			width: 5px;
			height: 15px;
			background: #409EFF;
			border-radius: 2px;
			margin-right: 8px;
			position: relative;
			top: 4px;
		}
	}

	.title2 {
		margin-top: 30px;
		margin-bottom: 30px;
	}

	// 第二部分
	.demo2 {
		box-sizing: border-box;
		width: 100%;
		padding: 20px;
		padding-top: 10px;
		min-height: 150px;
		display: flex;
		flex-wrap: wrap;
		border: 1px solid #D3D3D3;

		.demo2_label {
			cursor: pointer;
			height: 23px;
			margin-top: 10px;
			padding: 10px;
			background: #FFFFFF;
			border: 1px solid #D3D3D3;
			position: relative;

			& {
				margin-right: 20px;
			}

			&:hover div {
				display: block;
			}

			div {
				display: none;
				text-align: center;
				line-height: 12px;
				font-size: 12px;
				color: #FFFFFF;
				border-radius: 50%;
				position: absolute;
				right: -5px;
				top: -5px;
				height: 15px;
				width: 15px;
				background-color: #000000;
			}
		}

		.demo2_add {
			height: 23px;
			margin-top: 10px;
			cursor: pointer;
			padding: 10px;
			background: #FFFFFF;
			border: 1px dashed #D3D3D3;
		}
	}

	// <div class="demo2">
	// 		   <div class="demo2_label">
	// 			   付费用户
	// 			   <div>x</div>
	// 		   </div>
	// 		   <div class="demo2_add">
	// 			   付费用户
	// 			   <div>x</div>
	// 		   </div>
	// </div>
</style>